"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationError = void 0;
/**
 * A base class for any known error that occurs in our application.
 */
class ApplicationError extends Error {
    constructor(message, data) {
        super(message);
        this.data = data;
    }
}
exports.ApplicationError = ApplicationError;
//# sourceMappingURL=ApplicationError.js.map